import { LayoutController } from 'src/modules/layout/LayoutController'

export default {
  getChartColor () {
    return LayoutController.getInstance().getChartColor()
  },
  getChartOption () {
    return {
      xAxis: {
        type: 'category',
        data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
      },
      yAxis: {
        type: 'value'
      },
      series: [
        {
          data: [150, 230, 224, 218, 135, 147, 260],
          type: 'line'
        }
      ]
    }
  }
}
